import React, {useCallback, useEffect} from "react";
import Dialog from "../../base/dialog";
import TransactionReceiptInformation from "../../app-specific/transaction-receipt-information";
import useAccessLevels from "../../../hooks/use-access-levels";

const TransactionReceiptDialog = ({
                                      open,
                                      setOpen,
                                      title,
                                      customerId,
                                      receiptId,
                                  }) => {
    const operatorAccessLevels = useAccessLevels();

    /**
     * As soon as the dialog is opened, check if the operator has access to the sales.paymentReceipts package.
     * If not, close the dialog.
     */
    useEffect(() => {
        if (open && !operatorAccessLevels.packages.sales.paymentReceipts) {
            setOpen(false);
        }
    }, [open, setOpen, operatorAccessLevels.packages.sales.paymentReceipts]);

    /**
     * Closes the dialog
     * @type {function(): *}
     */
    const close = useCallback(() => setOpen(false), [setOpen]);

    return (
        <Dialog
            open={open}
            setOpen={close}
            maxWidth={'md'}
            className={'bound-dialog charge-credit-card-dialog'}
            scroll={'paper'}
            aria-labelledby="scroll-dialog-title"
        >
            {/*<DialogTitle id={'scroll-dialog-title'}>*/}
            {/*    <p className={`text-lg text-color-1 my-3 font-weight-bold text-center`}>*/}
            {/*        {title ?? 'Receipt'}*/}
            {/*    </p>*/}
            {/*    <Divider className='divider'/>*/}
            {/*</DialogTitle>*/}
            <TransactionReceiptInformation
                done={close}
                customerId={customerId}
                receiptId={receiptId}
            />
        </Dialog>
    );
}

export default TransactionReceiptDialog;
